export class StagingBucketConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanningRegion",
            "baseName": "scanningRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudAccountId",
            "baseName": "cloudAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StagingBucketConfig.attributeTypeMap;
    }
    constructor() {
    }
}
